import { ORDER_ORGANIZER_STATUSES, ORDER_ADMIN_STATUSES } from 'modules/Payments/constants';

import { sessionStore } from 'stores';

export const getOrderStatuses = () => {
  return sessionStore.isOrganizer ? ORDER_ORGANIZER_STATUSES : ORDER_ADMIN_STATUSES;
};
